import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'

import './index.css'


const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Rocky Yip Front End Developer Portfolio"
      meta={[
        { name: 'description', content: 'Rocky Yip Front End Developer Portfolio' },
        { name: 'keywords', content: 'Rocky Yip, Front End Developer, Vancouver' },
      ]}
    />
    <Header />
    <div className="contentwrapper">
      {children()}
    </div>
    <Footer/>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.node,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js